import { render, staticRenderFns } from "./AddCamera.vue?vue&type=template&id=36fe3f0a&scoped=true&"
import script from "./AddCamera.vue?vue&type=script&lang=js&"
export * from "./AddCamera.vue?vue&type=script&lang=js&"
import style0 from "./AddCamera.vue?vue&type=style&index=0&id=36fe3f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe3f0a",
  null
  
)

export default component.exports